import { type FC, useEffect, useState } from "react";
import { useShopfrontDispatch } from "../../../../_Bootstrap/hooks";
import { hideDialog } from "../../../../Actions/Dialogs/DialogActions";
import { addPaymentToSale } from "../../../../Actions/SellScreen/SellScreenPaymentActions";
import {
    addGiftCardToSale,
    type GiftCardPaymentRequest,
    type SaleAddGiftCardOptions,
} from "../../../../Actions/SellScreen/SellScreenProductActions";
import { getOption } from "../../../../Utilities/Platform/Options/Options";
import { getPolicy } from "../../../../Utilities/Platform/Policies/Policies";

const isPaymentRequest = (
    options: GiftCardPaymentRequest | SaleAddGiftCardOptions
): options is GiftCardPaymentRequest => {
    return typeof (options as GiftCardPaymentRequest).method === "string";
};

export const RequestGiftCardSource: FC<
    SaleAddGiftCardOptions | GiftCardPaymentRequest
> = options => {
    const [ sources, setSources ] = useState<Array<{ name: string; connection: string; }>>([]);
    const dispatch = useShopfrontDispatch();

    useEffect(() => {
        const enterpriseSources = getPolicy("gift_card_sources", []);

        const newSources = [];

        if(getOption("outlet_enable_gift_cards")) {
            newSources.push({
                name      : "Internal Gift Card",
                connection: "internal",
            });
        }

        newSources.push(...enterpriseSources);
        setSources(newSources);

        if(newSources.length === 1) {
            if(isPaymentRequest(options)) {
                dispatch(addPaymentToSale(options.method, options.amount, {
                    ...options.options,
                    source: newSources[0].connection,
                }));
            } else {
                dispatch(addGiftCardToSale({
                    ...options,
                    source: newSources[0].connection,
                }));
            }
        }
    }, [ dispatch, options ]);

    return (
        <div>
            <p>Please select which Gift Card the customer would like to buy.</p>
            <div className="flex justify-around gap-4">
                {sources.map(source => (
                    <div
                        className="border p-4 cursor-pointer"
                        key={source.connection}
                        onClick={() => {
                            dispatch(hideDialog());

                            if(isPaymentRequest(options)) {
                                dispatch(addPaymentToSale(options.method, options.amount, {
                                    ...options.options,
                                    source: source.connection,
                                }));
                            } else {
                                dispatch(addGiftCardToSale({
                                    ...options,
                                    source: source.connection,
                                }));
                            }
                        }}
                    >
                        {source.name}
                    </div>
                ))}
            </div>
        </div>
    );
};
